export default __webpack_public_path__ + "static/media/lode-runner.bc0838c3.png";